import {DeliveryStatus, DeliveryStatusType, TrackingEvent} from '../constants'

const readyEvents = [
    TrackingEvent.DISPATCH,
    TrackingEvent.COLLECT_REQUEST,
    TrackingEvent.COLLECT_WAIT,
    TrackingEvent.COLLECT_CARGO_FAIL,
]
const startEvents = [TrackingEvent.COLLECT_CARGO, TrackingEvent.COLLECT_CARGO_CANCEL]
const inDeliveryEvents = [TrackingEvent.DELIVERING, TrackingEvent.BRANCH_ARRIVAL]
const arrivingSoonEvents = [TrackingEvent.ESTIMATED_ARRIVAL, TrackingEvent.DELIVERY_FAIL]
const completedEvents = [TrackingEvent.DELIVERY_COMPLETION]

export function getDeliveryStatus({
    status,
    direction,
    trackable,
    expired,
    ableToPurchaseConfirm,
}: {
    status?: string
    direction?: string
    trackable: boolean
    expired: boolean
    ableToPurchaseConfirm: boolean
}): DeliveryStatusType {
    if (expired) {
        return DeliveryStatus.NO_TRACKING_EXPIRED
    }
    if (!trackable) {
        if (status === TrackingEvent.DELIVERY_COMPLETION) {
            return ableToPurchaseConfirm
                ? DeliveryStatus.NO_TRACKING_DELIVERY_COMPLETED
                : DeliveryStatus.NO_TRACKING_PURCHASE_CONFIRMED
        } else {
            return DeliveryStatus.NO_TRACKING_DELIVERY_STARTED
        }
    }

    if (!status || readyEvents.includes(status)) {
        return DeliveryStatus.READY
    } else if (startEvents.includes(status)) {
        return DeliveryStatus.START
    } else if (inDeliveryEvents.includes(status)) {
        return DeliveryStatus.IN_DELIVERY
    } else if (arrivingSoonEvents.includes(status)) {
        return DeliveryStatus.ARRIVING_SOON
    } else if (completedEvents.includes(status)) {
        if (direction === 'ORIGINAL' || direction === 'REDELIVERY') {
            return ableToPurchaseConfirm ? DeliveryStatus.COMPLETED : DeliveryStatus.PURCHASE_CONFIRMED
        } else {
            return DeliveryStatus.COMPLETED
        }
    }

    return DeliveryStatus.FAILED
}
